var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIconsHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a7521ea1-6814-4ec6-baa1-d3c4b28f6ace,.b90eb845-6fd4-4e5a-9450-fc344ea9c670{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.b90eb845-6fd4-4e5a-9450-fc344ea9c670{stroke-width:19.86px;}.a7521ea1-6814-4ec6-baa1-d3c4b28f6ace{stroke-width:20.58px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f51c5a6a-2750-4a5b-876c-31774b414f94",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "b90eb845-6fd4-4e5a-9450-fc344ea9c670",
    points: "11.5 200.59 199.46 36.35 388.5 200.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b90eb845-6fd4-4e5a-9450-fc344ea9c670",
    d: "M57.14,168.25V321.58A41.83,41.83,0,0,0,99,363.4H302.17A41.83,41.83,0,0,0,344,321.58V161.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b90eb845-6fd4-4e5a-9450-fc344ea9c670",
    d: "M267.39,302.3v-9.2A36.08,36.08,0,0,0,231.3,257H169.42a36.08,36.08,0,0,0-36.09,36.08v9.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a7521ea1-6814-4ec6-baa1-d3c4b28f6ace",
    cx: 200.03,
    cy: 177.31,
    r: 33.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconsHome);
export default __webpack_public_path__ + "static/media/web-icons_home.42642c8993e4a2c062fdbed3ac1153e2.svg";
export { ForwardRef as ReactComponent };